<template>
	<v-hover v-slot="{ hover }">
		<v-card
			:class="['category-card', { 'on-hover scale': hover }]"
			:elevation="hover ? 15 : 0"
		>
			<v-img
				:src="category.img"
				class="white--text align-end image"
				:gradient="
					`to bottom, rgba(0,0,0,.0), rgba(0,0,0,${hover ? 1 : 0.7})`
				"
			>
				<v-card-title class="card-title white--text">
					{{ category.name }}
				</v-card-title>

				<div class="card-on-hover" v-if="hover">
					<h3
						class="animate__animated animate__bounceIn animate__fast white--text font-weight-light"
					>
						Ver
					</h3>
				</div>
			</v-img>
		</v-card>
	</v-hover>
</template>

<script>
export default {
	name: "Simple",

	props: ["category"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.category-card {
	cursor: pointer;
	transition: all 0.2s;
}

.scale {
	transform: scale(1.1);
	z-index: 10;
}

.image {
	width: 275px;
	height: 250px;
}

.card-on-hover {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
	.scale {
		transform: initial;
	}

	.image {
		width: 110px;
		height: 110px;
	}

	.card-title {
		padding: 0 0 0 6px;
		font-size: 12px;
	}
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
	.scale {
		transform: initial;
	}

	.image {
		width: 120px;
		height: 120px;
	}

	.card-title {
		padding: 0 0 0 6px;
		font-size: 12px;
	}
}

/*Medium	md	Large tablet to laptop	960px > < 1264px**/
@media (min-width: 961px) and (max-width: 1264px) {
}

/*Large	lg	Desktop	1264px > < 1904px**/
@media (min-width: 1265px) and (max-width: 1904px) {
}

/*Extra large	xl	4k and ultra-wide*/
@media (min-width: 1904px) {
}
</style>
